import React from "react";
import Icon from "@ant-design/icons";

const NewAttendanceIconSVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none">
    <path
      d="M29.4375 6.8125L25.1875 2.5625C25.0965 2.46211 24.9861 2.38125 24.8629 2.32483C24.7398 2.2684 24.6064 2.23759 24.471 2.23425C24.3356 2.23092 24.2009 2.25513 24.0751 2.30543C23.9493 2.35572 23.8351 2.43105 23.7393 2.52684C23.6435 2.62263 23.5682 2.73688 23.5179 2.86266C23.4676 2.98845 23.4434 3.12314 23.4467 3.25856C23.45 3.39399 23.4809 3.52732 23.5373 3.65048C23.5937 3.77363 23.6746 3.88404 23.775 3.975L28.025 8.225C28.2116 8.40882 28.463 8.51206 28.725 8.5125C28.9905 8.51137 29.2455 8.40848 29.4375 8.225C29.6245 8.03753 29.7295 7.78354 29.7295 7.51875C29.7295 7.25395 29.6245 6.99996 29.4375 6.8125V6.8125Z"
      fill="url(#paint0_linear_426_215)"
    />
    <path
      d="M8.22505 2.56248C8.03758 2.37547 7.78359 2.27045 7.5188 2.27045C7.254 2.27045 7.00001 2.37547 6.81255 2.56248L2.56255 6.81248C2.37553 6.99995 2.27051 7.25394 2.27051 7.51873C2.27051 7.78353 2.37553 8.03752 2.56255 8.22498C2.7545 8.40847 3.0095 8.51136 3.27505 8.51248C3.53703 8.51205 3.78838 8.40881 3.97505 8.22498L8.22505 3.97498C8.41206 3.78752 8.51708 3.53353 8.51708 3.26873C8.51708 3.00394 8.41206 2.74995 8.22505 2.56248Z"
      fill="url(#paint1_linear_426_215)"
    />
    <path
      d="M28 15.65C27.9896 15.5629 27.9854 15.4752 27.9875 15.3875V15.3875C27.8368 12.4216 26.5917 9.61686 24.4929 7.51576C22.3941 5.41467 19.5908 4.16646 16.625 4.01251H15.375C12.4113 4.16619 9.60961 5.41264 7.51112 7.51113C5.41263 9.60962 4.16618 12.4113 4.0125 15.375V15.375C4.01456 15.4627 4.01038 15.5504 4 15.6375V16.3375C4.01038 16.4246 4.01456 16.5123 4.0125 16.6V16.6C4.16018 19.5682 5.40399 22.3759 7.50307 24.4796C9.60216 26.5833 12.4072 27.8333 15.375 27.9875H16.625C19.5887 27.8338 22.3904 26.5874 24.4889 24.4889C26.5874 22.3904 27.8338 19.5887 27.9875 16.625V16.625C27.9854 16.5373 27.9896 16.4496 28 16.3625V15.6625V15.65ZM23 17H16C15.7348 17 15.4804 16.8947 15.2929 16.7071C15.1054 16.5196 15 16.2652 15 16V9.00001C15 8.7348 15.1054 8.48044 15.2929 8.29291C15.4804 8.10537 15.7348 8.00001 16 8.00001C16.2652 8.00001 16.5196 8.10537 16.7071 8.29291C16.8946 8.48044 17 8.7348 17 9.00001V15H23C23.2652 15 23.5196 15.1054 23.7071 15.2929C23.8946 15.4804 24 15.7348 24 16C24 16.2652 23.8946 16.5196 23.7071 16.7071C23.5196 16.8947 23.2652 17 23 17Z"
      fill="url(#paint2_linear_426_215)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_426_215"
        x1="26.588"
        y1="2.23395"
        x2="26.588"
        y2="8.5125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#708AC2" />
        <stop offset="1" stop-color="#5673B2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_426_215"
        x1="5.3938"
        y1="2.27045"
        x2="5.3938"
        y2="8.51248"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#708AC2" />
        <stop offset="1" stop-color="#5673B2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_426_215"
        x1="16"
        y1="4.01251"
        x2="16"
        y2="27.9875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#708AC2" />
        <stop offset="1" stop-color="#5673B2" />
      </linearGradient>
    </defs>
  </svg>
);

const NewAttendanceIcon = (props) => (
  <Icon component={NewAttendanceIconSVG} {...props} />
);

export default NewAttendanceIcon;
